import template from './ScheduleItemView.html';
import { ScheduleItemController } from './ScheduleItemController';
export const ScheduleItemComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: ScheduleItemController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        schedule: '<',
        onDelete: '&?',
        canShowDownloadButton: '<?',
    },
};
